import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { User } from 'lucide-react';
import { COLUMNAS, PRIORIDADES } from '@/utils/tareaUtils';

export default function VistaResponsable({ tareas, trabajadores }) {
  const trabajadoresConTareas = trabajadores.filter(t => 
    tareas.some(tarea => tarea.responsable_id === t.id)
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {trabajadoresConTareas.map(trabajador => {
        const tareasTrabajador = tareas.filter(t => t.responsable_id === trabajador.id);
        return (
          <Card key={trabajador.id}>
            <CardHeader>
              <CardTitle className="text-lg flex items-center">
                <User className="w-5 h-5 mr-2" />
                {trabajador.nombre_completo}
                <Badge className="ml-2">{tareasTrabajador.length}</Badge>
              </CardTitle>
            </CardHeader>
            <CardContent>
              {tareasTrabajador.map(tarea => (
                <div key={tarea.id} className="mb-2 p-3 bg-gray-50 rounded hover:bg-gray-100 cursor-pointer transition">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <h4 className="font-semibold text-sm">{tarea.titulo}</h4>
                      <p className="text-xs text-gray-600">{COLUMNAS.find(c => c.id === tarea.estado)?.titulo}</p>
                    </div>
                    <Badge className={PRIORIDADES[tarea.prioridad].color} size="sm">
                      {PRIORIDADES[tarea.prioridad].icon}
                    </Badge>
                  </div>
                </div>
              ))}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
